import { Layout, Section } from 'layout';
import { BasketProvider } from 'pages/sales-lookup/hooks/use-basket';
import { BasketScreen } from 'pages/sales-lookup/screens/basket-screen';
import { FamilyDetailScreen } from 'pages/sales-lookup/screens/family-detail-screen';
import { LookupListScreen } from 'pages/sales-lookup/screens/lookup-list-screen';
import { PriceFeedbackScreen } from 'pages/sales-lookup/screens/price-feedback-screen';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

// Mobile-first module: rendered in the blank layout (no 268px sidebar) —
// the screens bring their own shell so the page works on a phone. The visit
// basket lives above the router so it survives every screen transition.
const SalesLookupPage = () => {
  const match = useRouteMatch();

  return (
    <BasketProvider>
      <Layout type={'blank_page_layout'}>
        <Section name={'content'}>
          <Switch>
            <Route path={`${match.url}/list`} component={LookupListScreen} />
            <Route path={`${match.url}/basket`} component={BasketScreen} />
            <Route path={`${match.url}/families/:familyId/feedback`} component={PriceFeedbackScreen} />
            <Route path={`${match.url}/families/:familyId`} component={FamilyDetailScreen} />
            <Redirect to={`${match.url}/list`} exact />
            <Route path='*' render={() => <Redirect to='/404' />} />
          </Switch>
        </Section>
      </Layout>
    </BasketProvider>
  );
};

export default SalesLookupPage;
